<app-add-form
  data-testid="coupon-add-form"
  [title]="
    (
      isViewMode()
        ? 'coupon.issue.form.view.title'
        : isEditMode()
          ? 'coupon.issue.form.edit.title'
          : 'coupon.issue.form.add.title'
    ) | translate
  "
  [formFields]="formFields"
  [headerActions]="headerActions"
  [editMode]="isEditMode()"
  [viewMode]="isViewMode()"
  [loading]="loading()"
  [initialData]="initialData()"
  [tableSections]="issuedCouponTableSections()"
  [enableOverflow]="false"
  (formAction)="onFormAction($event.action, $event.data)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>

<!-- Toast Messages -->
<p-toast data-testid="coupon-add-toast"></p-toast>
